<template>
    <div class="row">
        <ul class="d-flex justify-center breadcrumbs-app mb-4 mb-md-6">
            <li class="pa-1 pa-md-2 mx-1 mx-md-2" 
                :class="{'active' : addClassActive(item), 'last-child': item.lastItem, 'step-two': stepItem2Menu, 'edit-order': editOrder }" 
                v-for="(item, i) in wizardMenu" :key="i" 
                @click="backPage( item )">{{ itemTitleShow( item ) }}
            </li>
        </ul>
    </div>
</template>

<script>

//import Cookies from 'js-cookie'

export default {
    name: 'topBar',
    data() {
        return {
            currentPage: false,
            editOrder: false
        }
    },
    computed: {
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        }, 
        stepItem2Menu() {
            return this.$store.getters.stepItem2Menu;
        }, 
        setNextPage() {
            return this.$store.getters.setNextPage.length;
        }, 
    },
    methods: {
        itemTitleShow( item ) {
    
            if ( item.isActive == true ) {               
                return item.title;                
            } else {
                if( item.step <= this.setNextPage + 1 ) {
                    return item.title;
                } else {
                    return item.step;
                }
            }

        },        
        addClassActive(item) {
        
            if (item.step <= this.setNextPage + 1 ) {
                return true;
            } else {
                return false;
            }            
            
        },
        backPage( page ) {            
            
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            const order_id = params.get('order_id');

            if ( ! order_id) {
                this.$store.commit('setLastStep', false);
            
                let currentPage = null;
                this.wizardMenu.forEach((item) => {               
                    if(item.isActive == true) {
                        currentPage = item.step;                    
                    }
                });

                if( this.setNextPage + 1 >= page.step ) { 
                    this.wizardMenu[(+currentPage) - 1].isActive = false;  
                    this.wizardMenu[(+page.step) - 1].isActive = true;             
                }
            }
           
        }

    },
    async beforeMount() {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const order_id = params.get('order_id');

        if ( order_id ) {
            this.editOrder = true;
        }
    }
}

</script>
